import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useIntegrationsList } from '@/lib/api/integrations'
import { usePromotionSyncWithPolling } from '@/lib/api/promotions'

interface ShopifySyncPromotionButtonProps {
    storeId: string
    onSyncComplete?: () => void
}

/**
 * Button component to sync promotions from Shopify
 * Only displays if a Shopify integration is enabled for the store
 */
export const ShopifySyncPromotionButton = ({ storeId, onSyncComplete }: ShopifySyncPromotionButtonProps) => {
    const { data: integrations } = useIntegrationsList(storeId)
    const { handleSync, isLoading } = usePromotionSyncWithPolling(onSyncComplete)

    const hasShopifyIntegration = integrations?.some(
        (integration) => integration.provider === 'shopify' && integration.enabled
    )

    if (!hasShopifyIntegration) {
        return null
    }

    return (
        <Button
            onClick={() => handleSync({ storeId })}
            disabled={isLoading}
            variant="outline"
            size="sm"
        >
            <RefreshCw className={isLoading ? 'animate-spin' : ''} />
            {isLoading ? 'Syncing...' : 'Sync from Shopify'}
        </Button>
    )
}
